<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex md12>
        <v-card title>
          <v-card-title>
            <h2>Proveedores</h2>
          </v-card-title>
          <v-card-text>
            <DataTableProveedor :datatable="table" :on-success="btnAction" />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <GeneralDialog v-if="get_dialogMain.dialog" :form="formulario" action="proveedor.create-update"/>
  </v-container>
</template>

<script>
/*
import router from '@/router'
*/
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TableMainProveedor from '@/components/dataTableProveedor'
import GeneralDialog from '@/components/dialog/GeneralDialog'
export default {
  data: () => ({
    table: {
      header: {
        options: [
          {
            title: 'Refrescar',
            icon: 'mdi-cached',
            color: 'primary',
            action: 'refreshData'
          },
          {
            title: 'Nuevo',
            icon: 'mdi-plus',
            color: 'success',
            action: 'toCreate'
          }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Empresa', value: 'empresa.nombre', class: 'black--text' },
          { text: 'Activo', value: 'activo', class: 'black--text' },
          { text: '', value: 'data-table-expand' }
        ],
        loading: false
      },
      body: {
        data: []
      },
      footer: {
        paging: true
      }
    },
    formulario: {
      fields: [
        {
          type: 'text',
          name: 'Nombre del Proveedor',
          nameid: 'nombre',
          field: 'text',
          cols: 12
        },
        {
          url: '/empresas',
          name: 'Empresa',
          nameid: 'empresa_id',
          field: 'selectDataServer',
          cols: 12
        }
      ]
    }
  }),
  components: {
    DataTableProveedor: TableMainProveedor,
    GeneralDialog
  },
  mounted () {
    this.getDataUrl('proveedor.list')
  },
  methods: {
    btnAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getDataUrl('proveedor.list')
    },
    toCreate () {
      this.SHOW_DIALOG_MAIN({ type: 'create', withWindows: 800, title: 'Agregar Proveedor' })
    },
    ...mapActions(['getUrlServices', 'urlGetServicesActionList']),
    getDataUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.urlGetServicesActionList({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['CLEAR_OBJECTS', 'SHOW_DIALOG_MAIN'])

  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects'])
  },
  watch: {
    get_urls (val) {
      this.getDataUrl('proveedor.list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }
}
</script>
